// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { methanolSuggestionClearEnum } from './MethanolSuggestionClearEnum';
import { methanolSuggestionResponseEnum } from './MethanolSuggestionResponseEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationMethanolSuggestionId = (z.number());
export const fermentationMethanolSuggestion = z.object({
    id: fermentationMethanolSuggestionId,
    fermentation_id: fermentationId,
    model_version: z.string(),
    raised_at: z.date(),
    cleared_at: z.date().nullable(),
    clear_reason: methanolSuggestionClearEnum.nullable(),
    p_target_at_raise: z.number(),
    peak_p_target: z.number(),
    latest: z.unknown(),
    response: methanolSuggestionResponseEnum.nullable(),
    response_note: z.string().nullable(),
    responded_at: z.date().nullable(),
    responded_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const fermentationMethanolSuggestionInitializer = z.object({
    id: fermentationMethanolSuggestionId.optional(),
    fermentation_id: fermentationId,
    model_version: z.string(),
    raised_at: z.date(),
    cleared_at: z.date().optional().nullable(),
    clear_reason: methanolSuggestionClearEnum.optional().nullable(),
    p_target_at_raise: z.number(),
    peak_p_target: z.number(),
    latest: z.unknown(),
    response: methanolSuggestionResponseEnum.optional().nullable(),
    response_note: z.string().optional().nullable(),
    responded_at: z.date().optional().nullable(),
    responded_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const fermentationMethanolSuggestionMutator = z.object({
    id: fermentationMethanolSuggestionId.optional(),
    fermentation_id: fermentationId.optional(),
    model_version: z.string().optional(),
    raised_at: z.date().optional(),
    cleared_at: z.date().optional().nullable(),
    clear_reason: methanolSuggestionClearEnum.optional().nullable(),
    p_target_at_raise: z.number().optional(),
    peak_p_target: z.number().optional(),
    latest: z.unknown().optional(),
    response: methanolSuggestionResponseEnum.optional().nullable(),
    response_note: z.string().optional().nullable(),
    responded_at: z.date().optional().nullable(),
    responded_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=FermentationMethanolSuggestion.js.map